<template>
  <div>
    <!-- <top :adv="adv">
     <li slot="tips">批量充值、订单问题、套餐咨询可联系人工客服</li>
    </top>

    <div class="wrap_container">
      <el-container>
        <el-main>
          <tabs :coupons="coupons" :globe="globe" :smart="smart" :sun="sun" :theType="theType" :tm="tm" :dito="dito" :payments="payments" @checkLogin="getLogin"></tabs>
        </el-main>
      </el-container>
    </div>

    <el-container v-if="tab == 'first'">
      <div class="wrap_container mar-t-20 wrap_child">
        <el-main style="padding: 0 10px 4px;">
          <div class="">
            <tabs2 :coupons="coupons" :tm="tm" :theType="theType" :payments="payments" @checkLogin="getLogin"></tabs2>
          </div>
        </el-main>
      </div>
    </el-container> -->

    <!-- 改版新添加代码 s -->
    <HomeTop :advs="advs" />

    <div class="wrap_container flex-column">
      <tabs :coupons="coupons" ref="tabs" :globe="globe" :smart="smart" :sun="sun" :theType="theType" :tm="tm" :dito="dito" :payments="payments" @checkLogin="getLogin">
        <inputArea @func="getMsg(arguments)"></inputArea>
      </tabs>
    </div>

    <div v-if="tab == 'first'" class="wrap_container flex-column">
      <!-- <tabs2 :coupons="coupons" ref="tabs2" :tm="tm" :theType="theType" :payments="payments" @checkLogin="getLogin"></tabs2> -->
    </div>
    <!-- 改版新添加代码 e -->

    <el-main style="position: relative;padding: 0 20px;margin-top: 10px;">
      <el-button class="historycard" type="success" @click="share">分享</el-button>
      <notice></notice>
    </el-main>

    <el-footer>Developed by 龍科技</el-footer>
    <navBar :idx="0"></navBar>
    <fullguide :fullguidetype="fullguidetype" @funa="getType"></fullguide>

  </div>
</template>

<script>
  // 导入组件
  // 样式改版新添加代码 start
  import HomeTop from '@/page/components/home/top.vue'
  // 样式改版新添加代码 end
  import tabs from '@/components/tabs';    //其他套餐
  import tabs2 from '@/components/tabs2';  //TM套餐展示

  import grid from '@/components/grid.vue';
  import navBar from '@/components/navBar';
  import notice from '@/components/notice';
  import fullguide from '@/components/fullguide';
  import myswiper from '@/components/swiper.vue';
  // import top from '@/components/top';
  import {getUrlParam} from '@/util/util';
  import config from '@/config';
  var loading="";
  export default {
    name: 'choice',
    // 组件注册
    components: {
      // 新添加 s
      HomeTop,
      // 新添加 e
      navBar,
      tabs,
      tabs2,

      grid,
      notice,
      fullguide,
      myswiper,
      // top
    },
    data() {
      return {
        coupons: [],
        tab: 'first',
        theType: {
          id: 0,
          numbers: [],
        },
        radio1: 1,
        globe: {},
        smart: {},
        sun: {},
        tm: {},
        dito: {},
        payments: [],
        advs: { //广告图
          banner: [], //顶部轮播
          life: [], //生活缴费
          batch: [] //批量充值
        },
        swipers: [],
        adv: {
          pic: "",
          url: "",
        },
        fullguidetype: false,
      }
    },
    beforeCreate() { //组件生命周期函数
    },
    computed: {
      tabChanged () {
        return this.$store.state.tab;
      }
    },
    watch: {
      tabChanged(now) {
        this.tab = now;
      },
    },
    created() {
      this.theType.numbers = this.$route.params.numbers;
      this.theType.id = this.$route.params.type;
      if (!this.theType.numbers || this.theType.numbers.length <= 0 || this.theType.id == 0) {
        this.$router.push('/multiRecharge');
      }
      this.init();
    },
    mounted() {
    },
    methods: {
      init() {
        this.$api.request('System/init', {
          position: 1,
          client: this.$client,
          batch: 1
        }).then(({ data }) => {
            this.globe = data.globe;
            this.smart = data.smart;
            this.sun = data.sun;
            this.tm = data.tm;
            this.dito = data.dito;

            const advsKeys = Object.keys(data.advs)
            const advsValues = Object.values(data.advs)
            const newAdvs = {}
            advsKeys.forEach((item, index) => {
              newAdvs[`adv${item}`] = advsValues[index]
            })
            // 渲染顶部banner
            this.$set(this.advs, 'banner', newAdvs.adv1)
            // 生活缴费
            this.$set(this.advs, 'life', newAdvs.adv7)
            // 批量充值
            this.$set(this.advs, 'batch', newAdvs.adv8)

            // this.swipers = data.banners;
            // this.adv = data.adv;
            this.coupons = data.coupons;
            localStorage.setItem('banners', data.banners);
            if (typeof data.payments == 'object') {
              this.payments = data.payments;
              localStorage.setItem('payments', JSON.stringify(data.payments));
            }
            this.getLogin();
          })
          .catch(error => {
            this.$message({
              message: error+"加载数据失败，请检查网络！",
              type: "warning"
            })
            setTimeout(() => {
              this.init();
            }, 5000)
          });
      },
      getLogin(){
        let auth_token = localStorage.getItem('auth_token');
        if (!auth_token) {
          let code = this.$route.query.code || getUrlParam('code');
          switch(this.$client) {
           case 'wxh5':
              if (code) {
                this.$api
                  .request('Wx/grantLogin', { code: code })
                  .then(({ data }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                    this.$router.push('/');
                  });
              } else {
                window.location.href = config.api_url+'Wx/grant';
              }
              break;
           case 'magapp':
              if (code) {
                this.$api
                  .request('System/grantLogin', { code: code })
                  .then(({ data }) => {
                    this.$message({
                      message: "登录成功！",
                      type: "success"
                    })
                  })
                  .catch(error => {
                    this.$message({
                      message: "登录失败！",
                      type: "warning"
                    })
                     this.$router.push('/');
                  });
              } else {
                window.location.href = config.login_url;
              }
              break;
            case 'h5':
               if (code) {
                 this.$api
                   .request('System/grantLogin', { code: code })
                   .then(({ data }) => {
                     console.log(data);
                   })
                   .catch(error => {
                     this.$message({
                       message: "登录失败！",
                       type: "warning"
                     })
                     this.$router.push('/');
                   });
               } else {
                this.$confirm(' ', '请选择', {
                  distinguishCancelAndClose: true,
                  confirmButtonText: '登录充值',
                  cancelButtonText: '游客充值'
                }).then((action) => {
                  window.location.href = config.login_url;
                }).catch(() => {});
               }
              break;
           default:
              this.$message({
                 message: "非法客户端！",
                 type: "warning"
              })
              break;
          }
        }
      },
      getType(data) {
        if (!data) {
          this.fullguidetype = data
        }
      },
      share() {
        this.fullguidetype = true;
      },
      getMsg: function() {
        this.theType = {
          id: arguments[0][1],
          number: arguments[0][0],
          value: arguments[0][2]
        }
      }
    },
  }
</script>
<style lang="less">
  body {
    background: #EEEEEE !important;
  }
</style>
<style scoped>
  .el-container {
    /* background-color: #FFFFFF; */
    background-color: #EEEEEE;
    z-index: 2;
    box-sizing: border-box;
  }

  .wrap_container {
    position: relative;
    /* top: -80px; */
    /* background-color: #ffffff; */
    /* margin-left: 13px;
    margin-right: 13px; */
    border-radius: 9px;
    /* box-shadow: 0 0 5px #b22830; */
    border-radius: 9px;
    overflow: hidden;
    /* margin-top: 20px; */
    margin: 17px 5px 0 5px;
    background-color: #EEEEEE;
  }

  .wrap_tm {
    /*	width: 100%;
    padding: 20px 20px 0 20px;
            box-shadow: 0 0 5px #b22830;
            box-sizing: border-box;
               background-color: #FFFFFF;
                border-radius: 9px;*/




  }

  .wrap_child {
    margin: 0 13px;
    width: 100%;

  }

  .el-main {

    /* box-shadow: 5px 0px 5px -5px #b22830, -5px 0px 5px -5px #b22830; */
    /* box-shadow: 0 5px 5px #b22830; */
    /*    margin-left: 13px;
    margin-right: 13px;
    background-color: #FFFFFF;
    z-index: 2;
    border-radius: 9px;
    box-shadow: 0 5px 5px #b22830; */
  }

  .el-header {
    padding-top: 15px;
    background-color: #FFFFFF;
    z-index: 2;
    border-radius: 9px;


  }

  .mar-30 {
    margin-left: 30px;
    margin-right: 30px;
  }

  .pic_area {
    height: 2.5rem;
    line-height: 2.5rem;
    box-sizing: border-box;
    /*  margin-left: 100px;
    margin-right: 100px; */
    /* border-radius:20px; */
    /* border: 1px solid var(--theme-color); */
    display: flex;

  }

  header div {
    width: 100%;
  }

  .el-radio__input {
    display: none !important;
  }

  .el-header {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }

  .el-button {}

  .historycard {
    width: 50%;
    z-index: 999;
  }

  .mar-t-20 {
    margin-top: 20px;
  }
  /* .top {
    background: url(../../static/images/round.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: auto;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom:100px;
  } */
</style>



// WEBPACK FOOTER //
// src/page/choice.vue